import type { Schema } from '@cli-types/core-engine/schema.js'
import { collectInvalidDefaultValueFromErrors } from './collect-invalid-default-value-from-errors.js'
import { collectInvalidHeightErrors } from './collect-invalid-height-errors.js'
import { collectInvalidSchemaFieldTypeErrors } from './collect-invalid-schema-field-type-errors.js'
import { collectInvalidSlotErrors } from './collect-invalid-slot-errors.js'
import { collectMissingFieldPropertyErrors } from './collect-missing-field-property-errors.js'
import { collectMissingGeneratedSchemaTitleErrors } from './collect-missing-generated-schema-title-errors.js'
import { collectRequiredSchemaMetadataErrors } from './collect-required-schema-metadata-errors.js'
import { collectReservedAuthorshipFieldErrors } from './collect-reserved-authorship-field-errors.js'
import { collectSchemaSlotLayoutErrors } from './collect-schema-slot-layout-errors.js'
import { normalizeSchemaSlotLayout } from './normalize-schema-slot-layout.js'

export function validateSingleSchema(schema: Schema): string[] {
  const errors: string[] = []
  collectSchemaSlotLayoutErrors(schema, errors)
  const normalizedSchema = normalizeSchemaSlotLayout(schema)

  collectRequiredSchemaMetadataErrors(normalizedSchema, errors)
  if (normalizedSchema.type !== 'single') {
    errors.push('Single schema must have `type: "single"`')
  }

  collectMissingFieldPropertyErrors(normalizedSchema, errors)

  collectInvalidSchemaFieldTypeErrors(normalizedSchema.fields || [], errors)
  collectInvalidSlotErrors(normalizedSchema.fields || [], '', errors)
  collectInvalidHeightErrors(normalizedSchema.fields || [], '', errors)
  collectMissingGeneratedSchemaTitleErrors(normalizedSchema, 'Single', errors)
  collectInvalidDefaultValueFromErrors(normalizedSchema, errors)
  collectReservedAuthorshipFieldErrors(normalizedSchema, 'single', errors)

  return errors
}
